import { useState, useEffect } from 'react'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import CloudEditor from './ckeditor'; 

const Rte = ({contentTypeId, contentSetting, contentValue,setIsDraft, setLastSaved}) => {
    const[cValue, setCValue] = useState(contentValue)
    const[changesMade, setChangesMade] = useState(false)
    const [val, setVal] = useState('')

    useEffect(() => {
        const getValue = (contentSetting, cValue) => {
            if(cValue){
                if(cValue.contentDraft !== ""){
                    setVal(cValue.contentDraft)
                    setIsDraft(true)
                }else if(cValue.contentPublished !== ""){
                    setVal(cValue.contentPublished)
                }
            }else{
                setVal(contentSetting.defaultValue)
                setIsDraft(true)
            }
            
        }
        getValue(contentSetting, cValue)
    },[cValue,contentSetting])

    const updateValue = async () => {
        //console.log(val)
        var data = JSON.stringify( {
            value: val
            ,settingId: contentSetting.id
            ,settingAlias: contentSetting.settingAlias
        })
        const res = await fetch(`${global.config.Api.url}${global.config.Editor.publicToken}/ContentType/${contentTypeId}/values${cValue ? `/${cValue.id}` : ''}`,{
            method:(cValue ? 'PUT' : 'POST'),
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: data
        })
        setChangesMade(false)
        const response = await res
        try{
            if(!cValue){
                setCValue(response.json())
            }
        }catch(err){}
        setLastSaved(new Date())
    }

    const handleBlur = async e => {
        //e.preventDefault()
        await updateValue()
        setIsDraft(true)
    }

    return (
        <div className="cc_value_list_item_content"> 
            <CKEditor
                    editor={ CloudEditor }
                    data={val} 
                    onReady={ editor => {
                        // You can store the "editor" and use when it is needed.
                        editor.data.set(val)
                        console.log( 'Editor is ready to use!', editor, val );
                    } }
                    onChange={ ( event, editor ) => { 
                        const data = editor.getData();
                        setChangesMade(true)
                        setVal(data)
                        //console.log( { event, editor, data } );
                    } }
                    onBlur={ ( event, editor ) => { 
                        if(changesMade){
                            handleBlur()
                        }
                        //console.log( 'Blur.', editor );
                    } }
                    onFocus={ ( event, editor ) => {
                        //console.log( 'Focus.', editor );
                    } }
                />
        </div>
    )
}

export default Rte
